  // Recipe Kit Cart Event Listener
  // - event is dispatched everytime a cart item is added/removed from the recipe card
  // - use below function to update your sidebar/ajax cart number as needed.
  document.addEventListener('rk_cart_event', function (e) {
    // cart variable includes entirety of newly updated Shopify Cart, use accordingly
    var cart = e.detail.cart;
    console.log(cart);
                window.refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }
                  // Scroll to the top of the page unless the header is fixed
                    window.scroll({
                      top: 0,
                      left: 0,
                    });
  }, false);